import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { OperacionAFOPUTablaValorHistoricoGrupo } from '../types/dto';
import { OperacionAFOPUTablaValorHistoricoFields } from '../types/fields';
import { HttpAFOPU } from '../api/httoAFOPU';
import { pivotAFOPUData } from './useTablaValorAFOPU';

export const useAFOPUTablaValorHistorico = (idOperacion: number | undefined | null) => {
  const [versionIndex, setVersionIndex] = useState<number>(0);

  const {
    data: versiones = [],
    isLoading,
    isError,
    error,
    refetch
  } = useQuery<OperacionAFOPUTablaValorHistoricoGrupo[], Error>({
    queryKey: ['AFOPU-tabla-valor-historico', idOperacion],
    queryFn: () => HttpAFOPU.getTablaValoresHistorico(idOperacion!),
    enabled: !!idOperacion
  });

  const versionActual = versiones[versionIndex];

  const pivotData = useMemo(() => {
    if (!versionActual) return { headers: [], rows: [] };

    const celdas = versionActual[OperacionAFOPUTablaValorHistoricoFields.Celdas] || [];

    return pivotAFOPUData(celdas);
  }, [versionActual]);

  return {
    versiones,
    versionActual,
    versionIndex,
    setVersionIndex,
    headers: pivotData.headers,
    rows: pivotData.rows,
    isLoading,
    isError,
    error,
    refetch
  };
};
